import { CSSProperties, useRef, useState } from 'react';

import { Tooltip as MaTooltip } from '@project44/manifest-ds';

interface TooltipProps {
  children: JSX.Element[] | JSX.Element;
  message: string;
  messageClicked?: string;
  tooltipStyles?: CSSProperties;
  childrenStyles?: CSSProperties;
}

export const Tooltip = ({
  children,
  message,
  messageClicked,
  tooltipStyles,
  childrenStyles,
}: TooltipProps) => {
  const [dataTitle, setDataTitle] = useState<string>(() => message);

  const [visible, setVisible] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);

  const handleClicked = () => {
    if (messageClicked) {
      setDataTitle(messageClicked);
      setTimeout(() => {
        setDataTitle(message);
      }, 1000);
    }
  };

  return (
    <MaTooltip
      delay={2000}
      data-testid="tooltip"
      isOpen={visible}
      ref={wrapRef}
      title={dataTitle}
      style={tooltipStyles || {}}
    >
      <span
        data-testid="tooltip-children"
        key="tooltip-children"
        onClickCapture={handleClicked}
        onMouseEnter={() => {
          if (!visible) setVisible(true);
        }}
        onMouseLeave={() => {
          if (visible) setVisible(false);
        }}
        style={childrenStyles || {}}
      >
        {children}
      </span>
    </MaTooltip>
  );
};
